<template>
	<!-- 合同签订 -->
	<div>
		<div v-show="Htqd">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">合同签订</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:40px"></div>
					<span>组织架构</span>
					<el-cascader v-model="condition.organize_ids" clearable
					    style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>

					<div style="display:inline-block;margin-left:20px">
						<span>城市 </span>
						<el-select v-model="value" style="margin-left:10px;width:150px" placeholder="请选择" clearable>
							<el-option v-for="item in options" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-left:20px">
						<span>状态 </span>
						<el-select v-model="condition.is_signContract" style="margin-left:10px;width:150px"
							placeholder="请选择" clearable>
							<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>


					<!-- 按钮 -->
					<div style="display:inline-block;margin-left:20px">
						<el-button type="goon" @click="Find">查询</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:3% 3% 0 3%">
					<el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%"  height="540" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{ $globals.group_name + '/' + scope.row.range}}
							</template>
						</el-table-column>
						<el-table-column prop="city_id" align="center" label="城市"></el-table-column>
						<el-table-column prop="post_name" align="center" label="岗位"></el-table-column>
						<el-table-column prop="staff_name" align="center" label="姓名"></el-table-column>
						<el-table-column prop="staff_card" align="center" label="身份证号"></el-table-column>
						<el-table-column prop="staff_telephone" align="center" label="联系方式"></el-table-column>
						<el-table-column prop="" align="center" label="状态" width=100>
							<template slot-scope="scope">
								<img src="../../../assets/stateImg/状态_未签订.png"
									v-show="scope.row.is_signContract === '0'" />
								<img src="../../../assets/stateImg/状态_已签订.png"
									v-show="scope.row.is_signContract === '1'" />
							</template>
						</el-table-column>
						<el-table-column align="center" label="操作" width="120">
							<template slot-scope="scope">
								<el-button type="qian" @click="qian(scope.row)"
									v-show="scope.row.is_signContract === '0'">签订</el-button>
								<el-button disabled v-show="scope.row.is_signContract === '1'">已签订</el-button>
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>
		<!-- 签订 -->
		<el-dialog title="员工合同签订" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false" :center="true"
			:before-close="handleClose">
			<qian ref="qiandings" v-show="showqian"></qian>
		</el-dialog>
	</div>
</template>

<script>
	import qian from './Htqd_qian.vue';
	import axios from "axios";
	export default {
		components: {
			qian: qian,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				page_num: 1,
				page_size: 10,
				total: 0,
				dialogVisible: false,
				ids: [],
				tableData: [],
				enclosureList: [],
				fgsList: [],
				bkList: [],
				xmList: [],
				ztList: [{
					value: '0',
					label: '未签订'
				}, {
					value: '1',
					label: '已签订'
				}],
				// 权限
				Htqd: true,
				showqian: false,
				ruleForm: {
					id: "",
					staff_id: "",
					range: "",
					city_name: "",
					post_name: "",
					staff_name: "",
					staff_card: "",
					staff_telephone: "",
					start_date: "",
					end_date: "",
					is_signContract: "",

				},
				//条件
				condition: {
					id: "",
					organize_ids: [],
					company_name: "",
					city_name: "",
					modular_name: "",
					project_name: "",
					staff_name: "",
					staff_card: "",
					staff_telephone: "",
					start_date: "",
					end_date: "",
					post_name: "",
					is_signContract: "",
				},
				
				//组织架构数据
				organizeList: [],
				
				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
				    value: "id",
				    label: "organize_name",
				    children: "organizeList",
				    checkStrictly: true,
				    multiple: true,
				},

			}
		},
		methods: {
			// 全选
			handleSelectionChange(val) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				})
			},
			// 弹窗
			handleClose() {
				this.dialogVisible = false
			},
			// 操作详情
			qian(e) {
				this.dialogVisible = true;
				this.showqian = true;
				this.ruleForm.id = e.id;
				this.ruleForm.range = e.range;
				this.ruleForm.city_name = e.city_name; 
				this.ruleForm.post_name = e.post_name;
				this.ruleForm.staff_name = e.staff_name;
				this.ruleForm.staff_card = e.staff_card;
				this.ruleForm.staff_telephone = e.staff_telephone;
				this.ruleForm.start_date = e.start_date;
				this.ruleForm.end_date = e.end_date;
				this.ruleForm.is_signContract = e.is_signContract;
			},
			//查询
			Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
				    temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
				    organize_ids += item + ",";
				})
				
				const url = this.$globals.http + "staff/SelectSign";
				axios.post(url, {
					page_num: this.page_num,
					page_size: this.page_size,
					data_grouping: "Htqd",
					organize_ids: organize_ids,
					company_name: this.condition.company_name,
					city_name: this.condition.city_name,
					modular_name: this.condition.modular_name,
					project_name: this.condition.project_name,
					post_name: this.condition.post_name,
					staff_name: this.condition.staff_name,
					staff_card: this.condition.staff_card,
					staff_telephone: this.condition.staff_telephone,
					start_date: this.condition.start_date,
					end_date: this.condition.end_date,
					is_signContract: this.condition.is_signContract,
				}).then((response) => {
					var code = response.data.code;
					var data = response.data.data;
					if (code === '200') {
						this.tableData = data.list;
						this.total = data.total;
					} else {
						this.$message.warning("请求失败！请稍后重试");
					}
				}).catch((error) => {
					console.log(error)
					this.$message.error("服务器未响应！请稍后重试");
				})
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = "";
				this.ruleForm.company_name = "";
				this.ruleForm.city_name = "";
				this.ruleForm.modular_name = "";
				this.ruleForm.project_name = "";
				this.ruleForm.post_name = "";
				this.ruleForm.staff_name = "";
				this.ruleForm.staff_card = "";
				this.ruleForm.staff_telephone = "";
				this.ruleForm.start_date = "";
				this.ruleForm.end_date = "";
				this.ruleForm.is_signContract = "";
				this.enclosureList = "";
			},
			//初始化组织架构及下面的人
			async organizeFind() {
			    var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
			        identification: "1",
			    });
			    this.organizeList = this.getTreeData(organizeList.data);
			
			},
			getTreeData(data) {
			    // 循环遍历json数据
			    for (var i = 0; i < data.length; i++) {
			
			        if (data[i].organizeList.length < 1) {
			            // children若为空数组，则将children设为undefined
			            data[i].organizeList = undefined;
			        } else {
			            // children若不为空数组，则继续 递归调用 本方法
			            this.getTreeData(data[i].organizeList);
			        }
			    }
			    return data;
			}
		},
		async created() {
			this.Find();
			this.organizeFind();
		}
	}
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006E4B;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--qian:focus,
	.el-button--qian:hover {
		background: #006E4B;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--goon {
		color: #FFF;
		background-color: #006E4B;
		border-color: #006E4B;
		font-size: 15px;
		width: 85px;
	}

	.el-button--qian {
		color: #FFF;
		background-color: #006E4B;
		border-color: #006E4B;
		font-size: 13px;
		height: 40px;
		width: 80px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006E4B;
		border-color: #006E4B;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006E4B;
	}

	.el-checkbox__inner:hover {
		border-color: #006E4B;
	}
	
	.el-button+.el-button{
		margin-left: 0;
	}
</style>



// WEBPACK FOOTER //
// Htqd.vue?f7a70d8a